import React from "react";
export default function PermisosTableros() {
 return <details className="my-3 rounded border border-cyan-800 p-3 text-sm">
 <summary>Cómo se controlan los permisos</summary>
 <p>Ventana · Abrir permite entrar al módulo. Cada pestaña tiene su propio permiso para abrir y modificar. Tablero y Asistente se conceden por separado.</p>
 <p>En Reportería, Abrir permite consultar y Exportar habilita CSV, Excel e impresión/PDF. Auditoría es de solo lectura; su permiso de exportación no permite alterar registros.</p>
 <p>Los permisos no conceden acceso a recursos ajenos: también se requiere acceso al estanque o recurso. Los temporales solo reciben los permisos seleccionados, limitados por los de su creador.</p>
 </details>;
}
